import { render, staticRenderFns } from "./LgxOldJSONRenderer.vue?vue&type=template&id=109971d2&"
import script from "./LgxOldJSONRenderer.vue?vue&type=script&lang=js&"
export * from "./LgxOldJSONRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports